export const REACT_APP_API_URL = 'https://api-stg.criteriacorp.com/api/v1'; 
export const REACT_APP_ODA_URL = 'https://stg.ondemandassessment.com/'; 
export const REACT_APP_URL = 'http://talent-insights-v2.s3-website-us-east-1.amazonaws.com/'; 
export const REACT_APP_LOGOUT_URL = 'https://hireselect-stg.criteriacorp.com'; 
export const REACT_APP_HIRESELECT_URL = 'https://hireselect-stg.criteriacorp.com'; 
export const sskowk = 'n4Ws7sHmGQJ3w0GJ'; 
